var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeprecatedAlertIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.24988 16C13.6682 16 17.2499 12.4183 17.2499 8C17.2499 3.58172 13.6682 0 9.24988 0C4.83161 0 1.24988 3.58172 1.24988 8C1.24988 9.43769 1.62913 10.7868 2.29303 11.9528L0.847168 15.6788L4.46016 14.4083C5.79545 15.4079 7.45353 16 9.24988 16ZM8.33008 6.91687C8.33008 7.42104 8.74258 7.83354 9.24674 7.83354C9.75091 7.83354 10.1634 7.42104 10.1634 6.91687V5.08354C10.1634 4.57937 9.75091 4.16687 9.24674 4.16687C8.74258 4.16687 8.33008 4.57937 8.33008 5.08354V6.91687ZM8.33008 11.5002H10.1634V9.66687H8.33008V11.5002Z",
    fill: "#E15E5E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeprecatedAlertIcon);
export default __webpack_public_path__ + "static/media/DeprecatedAlertIcon.243139aa20f8b88941a34f7151814739.svg";
export { ForwardRef as ReactComponent };